import React from 'react';
import { history } from 'containers/App';

import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LogoutPage = () => {
  function login() {
    history.push('/');
    window.location.reload();
  }

  return (<section className="logout-page">
    <div className="row">
      <div className="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 offset-lg-4 col-lg-4">
        <h1>Logged Out</h1>
        <span className="check-icon">
          <FontAwesomeIcon icon="check-circle" size="4x" />
        </span>
        <h3><FormattedMessage id="logoutPage.intro" /></h3>
        <p><FormattedMessage id="logoutPage.disclaimer" /></p>
        <p><button type="button" className="btn btn-link" onClick={ () => login() }>Log Back In</button></p>
      </div>
    </div>
  </section>);
};

export default LogoutPage;
